import React from 'react'
import {Button} from 'common/Button'
import {FollowButton} from 'common/FollowButton'
import styles from './Nav.scss'
import {Navbar, NavbarGroup, NavbarTitle} from 'common/Navbar'
import timeago from 'timeago.js'
import {Link} from 'react-router'
import {Icon} from 'common/LegacyIcon'

const formatDate = (date) => {
  if (!date) {
    // no publication date means this report is not yet published and we're
    // previewing.
    return 'just now'
  } else {
    return timeago().format(date)
  }
}

export const Nav = ({rides, publishedAt, author, reportSlug, canEdit, currentUser, isFollowing, onIsFollowingChange, contestEntry}) => (
  <Navbar>
    <NavbarGroup>
      <li><NavbarTitle to='/ride_reports'>Ride Reports</NavbarTitle></li>
      <li>report by <Link to={`/ride_reports/user/${author.id}`} className={styles.authorLink}>{author.name}</Link></li>
      {currentUser.id && currentUser.id !== author.id &&
        <li><FollowButton isFollowing={isFollowing} onChange={onIsFollowingChange} /></li>}
      <li className={styles.collapse}>{formatDate(publishedAt)}</li>
      {contestEntry && <li><a href='/ride_reports/rollout' target='_blank'><Icon i='star' size={18} /> <span style={{lineHeight: '18px', display: 'inline-block', verticalAlign: 'middle'}}>Contest Entry</span></a></li>}
    </NavbarGroup>
    <NavbarGroup>
      {rides.length === 1 &&
        <li><a href={`/trips/${rides[0]}`}>Go to map view &raquo;</a></li>}
      {canEdit &&
        <li className={styles.collapse}><Link to={`/ride_reports/${reportSlug}/edit`}><Button>Edit</Button></Link></li>}
    </NavbarGroup>
  </Navbar>
)
